import React, { useState, useCallback, useEffect } from 'react';
import block from 'bem-cn';
import { useSelector, useDispatch } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';

import Input from 'components/Input';
import Button from 'components/Button';
import { actions } from '../../redux';
import LanguageDropdownSelector from 'components/LanguageDropdownSelector';
import useCaptcha from 'features/Auth/model/useCaptcha';
import { RECAPTCHA_SITE_KEY } from 'features/Auth/model/captchaConstants';

import './Auth.scss';

const b = block('auth');

const Auth = () => {
  const [userName, changeUserName] = useState('');
  const [password, passwordUserName] = useState('');
  const [disable, setDisable] = useState(true);

  const locale = useSelector(state => state.locale.locale);
  const { isProcess } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const { values, handlers } = useCaptcha();

  const signIn = useCallback(() => {
    if (isProcess || values.isCooldownActive) return;

    if (!handlers.validateCaptchaBeforeLogin()) return;

    dispatch(actions.login(userName, password, handlers.handleLoginResult));
  }, [
    userName,
    password,
    isProcess,
    values.isCooldownActive,
    handlers.validateCaptchaBeforeLogin,
    handlers.handleLoginResult,
    dispatch,
  ]);

  useEffect(() => {
    if (password.length !== 0 && userName.length !== 0) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [password, userName]);

  return (
    <section className={b()}>
      <div className={b('content')}>
        <div className={b('title')}>
          <span className={b('title-text')}>{locale.agentPlatfrom}</span>
          <span className={b('title-login')}>{locale.login}</span>
        </div>
        <div className={b('form')}>
          <div className={b('input-block')}>
            <div className={b('input-block', 'title')}>{locale.login}</div>
            <Input
              value={userName}
              onChange={e => changeUserName(e.currentTarget.value)}
              placeholder={locale.name}
              size="low"
            />
          </div>
          <div className={b('input-block')}>
            <div className={b('input-block', 'title')}>{locale.password}</div>
            <Input
              value={password}
              onChange={e => passwordUserName(e.currentTarget.value)}
              type="password"
              withEye
              size="low"
              placeholder="●●●●●●●●●●●●"
            />
          </div>
          <div className={b('button')}>
            <Button text={locale.access} callBack={signIn} disabled={disable || isProcess || values.isCooldownActive} />
          </div>
        </div>
        {values.showCaptcha && (
          <div className={b('captcha')}>
            <div className={b('captcha-widget')}>
              <ReCAPTCHA
                key={values.captchaLanguage}
                ref={values.recaptchaRef}
                sitekey={RECAPTCHA_SITE_KEY}
                hl={values.captchaLanguage}
                size="normal"
                type="image"
                onChange={handlers.handleCaptchaChange}
                onExpired={handlers.handleCaptchaExpired}
                onErrored={handlers.handleCaptchaErrored}
                theme="light"
              />
            </div>
            {values.captchaMessage && <div className={b('captcha-message')}>{values.captchaMessage}</div>}
          </div>
        )}
        <div className={b('other')}>
          <span>{locale.other}</span>
        </div>
        <div className={b('language-selector')}>
          <LanguageDropdownSelector />
        </div>
      </div>
    </section>
  );
};

export default Auth;
